
export default {
	props: {
		list: {
			type: [Array, undefined, null],
			required: true
		}
	}
}
